import { Award, GraduationCap, Heart, Shield } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const AboutSection = () => {
  const { t } = useLanguage();
  
  const credentials = [
    {
      icon: Award,
      title: t("about.yearsExp"),
      description: t("about.yearsExpDesc"),
    },
    {
      icon: GraduationCap,
      title: t("about.acls"),
      description: t("about.aclsDesc"),
    },
    {
      icon: Shield,
      title: t("about.rn"),
      description: t("about.rnDesc"),
    },
    {
      icon: Heart,
      title: t("about.rated"),
      description: t("about.ratedDesc"),
    },
  ];

  return (
    <section
      id="about"
      className="section-padding bg-background"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <div className="relative">
            <div className="aspect-[4/5] rounded-2xl overflow-hidden">
              <img
                src="https://customer-assets.emergentagent.com/job_85a700af-9f96-42a1-b28b-49447854ad83/artifacts/5zixdtan_k54.jpg"
                alt="Karine Lauzon RN"
                className="w-full h-full object-cover object-center"
                data-testid="about-image"
              />
            </div>
            {/* Floating Card */}
            <div className="absolute -bottom-6 -right-6 md:bottom-8 md:-right-8 glass rounded-xl p-6 max-w-xs shadow-xl bg-white/90 backdrop-blur-sm">
              <div className="flex items-center gap-4">
                <div className="p-3 bg-accent/20 rounded-full">
                  <Award className="w-8 h-8 text-accent" />
                </div>
                <div>
                  <p className="font-semibold text-lg">{t("about.yearsExp")}</p>
                  <p className="text-sm text-muted-foreground">{t("about.excellence")}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div>
            <span className="font-mono-label text-xs text-primary tracking-widest">
              {t("about.title")}
            </span>
            <h2
              className="text-3xl sm:text-4xl lg:text-5xl font-semibold mt-4 mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              {t("about.heading")} <span className="italic text-primary">{t("about.headingAccent")}</span>
            </h2>
            
            <div className="space-y-4 text-muted-foreground mb-8">
              <p>{t("about.p1")}</p>
              <p>{t("about.p2")}</p>
              <p>{t("about.p3")}</p>
            </div>

            {/* Credentials Grid */}
            <div className="grid grid-cols-2 gap-4">
              {credentials.map((item, index) => (
                <div
                  key={index}
                  className="p-4 bg-muted rounded-xl"
                  data-testid={`credential-${index}`}
                >
                  <item.icon className="w-6 h-6 text-primary mb-2" />
                  <p className="font-semibold">{item.title}</p>
                  <p className="text-xs text-muted-foreground">{item.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
